<template>
	<div class="all-wrap">
		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>

		<!-- 顶部 banner 区(站内风格:暗色大图 + 顶部导航) -->
		<div class="videolist-banner">
			<!-- 顶部导航栏 -->
			<Headernew />

			<div class="wow fadeInUp bannertop-title">
				<div>项目方案 · 详情分享</div>
				<div>——后天科技·管理方案、报价、作品与案例</div>
			</div>
		</div>

		<!-- ===================== 页主体：项目方案 · 详情分享 ===================== -->
		<div class="app-container" ref="contentArea">
			<div class="page-header">
				<h1>
					<i class="iconfont icon-shoushimima"></i> 项目方案
				</h1>
			</div>

			<!-- Tab 切换 -->
			<div class="tabs">
				<button v-for="t in tabList" :key="t.key" class="tab-btn"
					:class="{ active: activeTab === t.key }" @click="switchTab(t.key)">
					<i :class="t.icon"></i> {{ t.text }}
				</button>
			</div>

			<!-- ============ 方案面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'scheme'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="schemeName" placeholder="请输入名称" @keyup.enter="loadScheme" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<input class="search-input" type="text" v-model="schemeTags" placeholder="请输入标签" @keyup.enter="loadScheme" />
						</span>
						<button class="search-btn" @click="loadScheme"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
					<!-- 方案模板：新窗口打开 -->
					<button class="template-btn" @click="openTemplate('scheme')"><i class="iconfont icon-dianying"></i> 方案模板</button>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedScheme.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无方案</p>
					</div>
					<div class="timeline-item" v-for="item in sortedScheme" :key="item.id" @click="toSchemeDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 报价面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'budget'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="budgetName" placeholder="请输入名称" @keyup.enter="loadBudget" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<input class="search-input" type="text" v-model="budgetTags" placeholder="请输入标签" @keyup.enter="loadBudget" />
						</span>
						<button class="search-btn" @click="loadBudget"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
					<!-- 报价模板：新窗口打开 -->
					<button class="template-btn" @click="openTemplate('budget')"><i class="iconfont icon-add"></i> 报价模板</button>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedBudget.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无报价</p>
					</div>
					<div class="timeline-item" v-for="item in sortedBudget" :key="item.id" @click="toBudgetDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 作品面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'works'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="workName" placeholder="请输入名称" @keyup.enter="loadWorks" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<input class="search-input" type="text" v-model="workTags" placeholder="请输入标签" @keyup.enter="loadWorks" />
						</span>
						<button class="search-btn" @click="loadWorks"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedWorks.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无作品</p>
					</div>
					<div class="timeline-item" v-for="item in sortedWorks" :key="item.id" @click="toWorkDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 案例面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'cases'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="caseName" placeholder="请输入名称" @keyup.enter="loadCases" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<input class="search-input" type="text" v-model="caseTags" placeholder="请输入标签" @keyup.enter="loadCases" />
						</span>
						<button class="search-btn" @click="loadCases"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedCases.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无案例</p>
					</div>
					<div class="timeline-item" v-for="item in sortedCases" :key="item.id" @click="toCaseDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<!-- 底部页脚(项目统一) -->
		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'

export default {
	name: 'projectProposal',
	components: { Headernew, Footernew, Comment, gotop },
	data() {
		return {
			activeTab: 'scheme',
			tabList: [
				{ key: 'scheme', text: '方案', icon: 'iconfont icon-shipinbofangyingpian' },
				{ key: 'budget', text: '报价', icon: 'iconfont icon-add' },
				{ key: 'works', text: '作品', icon: 'iconfont icon-dianying' },
				{ key: 'cases', text: '案例', icon: 'iconfont icon-Dmoxingx' },
			],

			// 列表数据(后端接口)
			schemeList: [],
			budgetList: [],
			worksList: [],
			casesList: [],

			// 搜索关键词
			schemeName: '',
			schemeTags: '',
			budgetName: '',
			budgetTags: '',
			workName: '',
			workTags: '',
			caseName: '',
			caseTags: '',

			// 模板链接（新窗口打开）
			templateUrls: {
				scheme: 'https://xjaikj.htkjbd.com/guanwangmuban/%E6%96%B9%E6%A1%88%E6%A8%A1%E6%9D%BF.html',
				budget: 'https://xjaikj.htkjbd.com/guanwangmuban/%E6%8A%A5%E4%BB%B7%E6%A8%A1%E6%9D%BF.html',
			},

			// 从 URL 进入时是否需要定位到内容区
			needScrollContent: false,
		}
	},
	computed: {
		// 各列表按时间倒序排列(用于时间轴)
		sortedScheme() { return this.sortByTime(this.schemeList) },
		sortedBudget() { return this.sortByTime(this.budgetList) },
		sortedWorks() { return this.sortByTime(this.worksList) },
		sortedCases() { return this.sortByTime(this.casesList) },
	},
	watch: {
		// 详情页面包屑跳回本页(路径同为 /projectProposal,可能仅 query 变化)时重新定位 tab
		'$route'() { this.applyRouteQuery(this.$route.query) },
	},
	created() {
		this.applyRouteQuery(this.$route.query)
	},
	mounted() {
		this.loadScheme()
		this.loadBudget()
		this.loadWorks()
		this.loadCases()
		// 详情面包屑返回后，滚动到 Tab 内容区
		if (this.needScrollContent) {
			this.$nextTick(() => {
				const el = this.$refs.contentArea
				if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' })
			})
		}
	},
	methods: {
		// 根据 URL query 切换 Tab
		applyRouteQuery(q) {
			q = q || {}
			if (q.tab === 'budget' || q.tab === 'works' || q.tab === 'cases') {
				this.activeTab = q.tab
				this.needScrollContent = true
			}
		},
		switchTab(tab) { this.activeTab = tab },

		// 时间轴排序:按 created_at 倒序
		sortByTime(list) {
			if (!Array.isArray(list)) return []
			return [...list].sort((a, b) => {
				const t = (v) => new Date((v || '').replace(' ', 'T')).getTime() || 0
				return t(b.created_at) - t(a.created_at)
			})
		},
		// 日期只取年月日
		fmtDate(v) {
			if (!v) return ''
			return String(v).slice(0, 10)
		},

		// 通用分拆 tags(可能以逗号/顿号分隔)
		splitTags(tags) {
			if (!tags) return []
			return String(tags).split(/[,，]/).map(s => s.trim()).filter(Boolean)
		},

		// ---- 方案列表 ----
		loadScheme() {
			this.$axios.get(this.$api + '/getHtmlPage', {
				params: { style: 'html', name: this.schemeName || undefined, tags: this.schemeTags || undefined }
			}).then(res => {
				this.schemeList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// ---- 报价列表 ----
		loadBudget() {
			this.$axios.get(this.$api + '/getHtmlPage', {
				params: { style: 'page', name: this.budgetName || undefined, tags: this.budgetTags || undefined }
			}).then(res => {
				this.budgetList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// ---- 作品列表 ----
		loadWorks() {
			this.$axios.get(this.$api + '/getWorksCase', {
				params: { style: 'work', name: this.workName || undefined, tags: this.workTags || undefined }
			}).then(res => {
				this.worksList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// ---- 案例列表 ----
		loadCases() {
			this.$axios.get(this.$api + '/getWorksCase', {
				params: { style: 'case', name: this.caseName || undefined, tags: this.caseTags || undefined }
			}).then(res => {
				this.casesList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},

		// ---- 跳转详情 ----
		toSchemeDetail(id) { this.$router.push({ path: '/schemeDetail', query: { id } }) },
		toBudgetDetail(id) { this.$router.push({ path: '/budgetDetail', query: { id } }) },
		toWorkDetail(id) { this.$router.push({ path: '/workDetail', query: { id } }) },
		toCaseDetail(id) { this.$router.push({ path: '/caseDetail', query: { id } }) },

		// ---- 模板：新窗口打开，追加时间戳参数 t 防缓存 ----
		openTemplate(type) {
			let url = this.templateUrls[type]
			if (!url) return
			url += (url.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now()
			window.open(url, '_blank')
		},
	},
}
</script>

<style scoped>
/* 统一盒模型，避免 width:100% + padding 导致手机端右侧溢出贴边 */
.all-wrap,
.all-wrap * {
	box-sizing: border-box;
}

/* 顶部 banner 区(站内风格) */
.videolist-banner {
	width: 100%;
	height: 700px;
	background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg);
	background-size: 100% 100%;
	position: relative;
}
.bannertop-title { width: 100%; position: absolute; left: 0; top: 30%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 61px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 35px auto 0; font-size: 31px; color: #fff; text-align: right; letter-spacing: 2px; }

/* 主体内容区 */
.app-container { max-width: 1280px; margin: 0 auto; padding: 2rem 1.5rem 4rem; }
.page-header { margin-bottom: 2rem; }
.page-header h1 { font-size: 1.75rem; font-weight: 600; color: #0a2540; display: flex; align-items: center; gap: .75rem; }
.page-header h1 i { color: #2563eb; }

/* Tab：更醒目的实心分段控件（大按钮 + 品牌红激活态） */
.tabs { display: inline-flex; gap: .5rem; background: #e8edf4; padding: .45rem; border-radius: 999px; flex-wrap: wrap; margin-bottom: 1.5rem; box-shadow: inset 0 2px 5px rgba(15,23,42,.12); }
.tab-btn { background: #fff; border: 1.5px solid #cbd5e1; padding: .8rem 1.9rem; font-size: 1.05rem; font-weight: 700; color: #475569; cursor: pointer; border-radius: 999px; transition: all .16s; display: flex; align-items: center; gap: .5rem; box-shadow: 0 2px 4px rgba(15,23,42,.08); }
.tab-btn i { font-size: 1.25rem; opacity: .85; }
.tab-btn:hover { color: #2563eb; border-color: #93c5fd; background: #f0f6ff; transform: translateY(-2px); box-shadow: 0 6px 14px rgba(37,99,235,.18); }
.tab-btn.active { color: #fff; background: linear-gradient(135deg, #3b82f6, #2563eb); border-color: #2563eb; box-shadow: 0 8px 20px rgba(37,99,235,.45), 0 0 0 3px rgba(37,99,235,.15); transform: translateY(-1px) scale(1.04); }
.tab-btn.active i { opacity: 1; }
.tab-btn.active:hover { color: #fff; background: linear-gradient(135deg, #3b82f6, #2563eb); transform: translateY(-1px) scale(1.04); }

.tab-panel { background: #fff; border-radius: 16px; padding: 1.5rem 1.5rem 2rem; box-shadow: 0 4px 12px rgba(0,0,0,.03); min-height: 420px; }

/* 工具栏 + 搜索 */
.panel-toolbar { margin-bottom: 1.25rem; }
.search-wrap { display: flex; gap: .75rem; flex-wrap: wrap; align-items: center; }
.search-field { display: flex; align-items: center; gap: .4rem; flex: 1; min-width: 180px; }
.search-label { flex-shrink: 0; font-size: .9rem; font-weight: 600; color: #475569; }
.search-input { flex: 1; min-width: 0; width: 100%; padding: .5rem .75rem; border: 1px solid #e2e8f0; border-radius: 8px; font-size: .9rem; outline: none; }
.search-input:focus { border-color: #2563eb; }
.search-btn { background: #2563eb; color: #fff; border: none; padding: .5rem 1.2rem; border-radius: 8px; font-weight: 500; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: .3rem; transition: background .2s; }
.search-btn:hover { background: #1d4ed8; }

/* 模板按钮：搜索框下方，独立醒目（描边样式，区别于搜索按钮） */
.template-btn { margin-top: .85rem; background: #fff; color: #2563eb; border: 1.5px solid #2563eb; padding: .55rem 1.3rem; border-radius: 999px; font-weight: 600; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: .4rem; transition: all .18s; }
.template-btn i { font-size: 1rem; }
.template-btn:hover { background: #2563eb; color: #fff; box-shadow: 0 6px 14px rgba(37,99,235,.3); transform: translateY(-1px); }

/* 时间轴列表：每行 = marker列(点+竖线) + 内容列，点自然落在线上 */
.timeline { margin-top: .5rem; }
.timeline-item { position: relative; display: flex; cursor: pointer; }
.timeline-item .tl-marker {
	position: relative;
	width: 28px;               /* marker 列固定宽度 */
	flex: 0 0 28px;
	display: flex;
	justify-content: center;
}
/* 竖线：贯穿每个 item，连接上下圆点 */
.timeline-item .tl-marker::before {
	content: '';
	position: absolute;
	left: 50%;
	top: 0;
	bottom: 0;
	width: 2px;
	transform: translateX(-50%);
	background: #e2e8f0;
}
/* 圆点：正好画在线条顶端中心 */
.timeline-item .tl-marker::after {
	content: '';
	position: absolute;
	top: 4px;
	left: 50%;
	transform: translateX(-50%);
	width: 14px;
	height: 14px;
	background: #2563eb;
	border-radius: 9999px;
	border: 2px solid #fff;
	box-shadow: 0 0 0 3px #dbeafe;
	z-index: 1;
}
/* 最后一项：不向下画多余线条 */
.timeline-item:last-child .tl-marker::before { bottom: auto; height: 10px; }

/* 内容列 */
.timeline-item .tl-body { flex: 1; min-width: 0; padding-bottom: 1.5rem; }
.tl-date { font-size: .8rem; font-weight: 600; color: #2563eb; letter-spacing: .3px; margin-bottom: .3rem; text-align: left; }
.tl-card { padding: .75rem 1rem; background: #fafcff; border-radius: 10px; border: 1px solid #eef2f6; transition: all .15s; text-align: left; }
.tl-card:hover { background: #fff; border-color: #dbeafe; box-shadow: 0 2px 8px rgba(0,0,0,.03); }
.tl-title { font-weight: 600; font-size: 1rem; color: #0a2540; text-align: left; }
.tl-tags { display: flex; flex-wrap: wrap; gap: .3rem; margin-top: .3rem; text-align: left; }
.tl-tags span { background: #f1f5f9; font-size: .7rem; padding: .1rem .6rem; border-radius: 12px; color: #475569; }
.tl-hint { display: inline-flex; align-items: center; gap: .2rem; font-size: .7rem; color: #94a3b8; margin-top: .35rem; transition: color .2s; }
.tl-hint i { font-size: .6rem; display: inline-block; transform: rotate(-90deg); }
.timeline-item:hover .tl-hint { color: #2563eb; }
.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

/* 响应式 */
@media (max-width: 768px) {
	.videolist-banner { height: 380px; }
	.bannertop-title { top: 40%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	.tab-btn { padding: .65rem 1rem; font-size: .9rem; }
}
@media (max-width: 480px) {
	/* 手机端：Tab 改为 2×2 等分网格，等宽居中，不横向滚动 */
	.tabs { display: grid; grid-template-columns: repeat(2, 1fr); gap: .45rem; width: 100%; padding: .45rem; border-radius: 14px; }
	.tab-btn { justify-content: center; padding: .7rem .5rem; font-size: .92rem; border-radius: 12px; transform: none; }
	.tab-btn i { display: inline-flex; font-size: 1.05rem; }
	.tab-btn.active { transform: scale(1.02); }
	/* 手机端搜索：字段换行铺满，名称/标签各占一行，搜索按钮整行 */
	.search-wrap { flex-direction: column; align-items: stretch; gap: .6rem; }
	.search-field { width: 100%; min-width: 0; }
	.search-btn { width: 100%; justify-content: center; }
}
</style>

<style>
@import '../assets/css/alibaba.css';
</style>